/**
 * Send a post message to a native application.
 * We check for apple and android notification buses.
 * If a bus is found, we send a notification message to it.
 *
 * @param {object} data
 * @param {int} delay the number of milliseconds to delay before sending the notification.
 */
export default function notifyNativeApp(data, delay = 0) {
    let appleNotification = window.webkit?.messageHandlers?.unityMessageHandler
    let androidNotification = window.androidInterface?.unityMessageHandler

    if (appleNotification !== undefined) {
        setTimeout(() => window.webkit.messageHandlers.unityMessageHandler.postMessage(data), delay)
    } else if (androidNotification !== undefined) {
        setTimeout(() => window.androidInterface.unityMessageHandler(JSON.stringify(data)), delay)
    } else {
        setTimeout(() => console.warn('no notification bus found.'), delay)
    }

}
